export const FONTS = {
  // black: 'Roboto-Black',
  bold: 'bold',
  light: '200',
  regular: '400'
}
